import React from 'react'

interface StatusBadgeProps {
  status:
    | 'Active'
    | 'Inactive'
    | 'Deactivated'
    | 'Pending'
    | 'Due'
    | 'Completed'
    | 'Not Started'
    | 'In review'
    | 'Approved'
    | 'Denied'
    | 'Connected'
    | 'Invited'
}

const StatusBadge: React.FC<StatusBadgeProps> = ({status}) => {
  const getBadgeStyles = () => {
    switch (status) {
      case 'Active':
      case 'Completed':
      case 'Approved':
      case 'Connected':
        return {
          badgeClass: 'badge-primary',
          color: '#0E9F6E',
          background: '#E8F8F4',
        }
      case 'Inactive':
      case 'Due':
      case 'Denied':
        return {
          badgeClass: 'badge-danger',
          color: '#EE3043',
          background: '#FFF5F8',
        }
      case 'Deactivated':
      case 'Pending':
      case 'Not Started':
        return {
          badgeClass: 'badge-dark',
          color: '#000',
          background: '#F6F6F6',
        }
      case 'In review':
        return {
          badgeClass: 'badge-warning',
          color: '#B85407',
          background: '#FAE9D2',
        }
      case 'Invited':
        return {
          color: '#3B82F6',
          background: '#E3F0FF',
        }
      default:
        return {
          badgeClass: 'badge-primary',
          color: '#0E9F6E',
          background: '#E8F8F4',
        }
    }
  }

  const {badgeClass, color, background} = getBadgeStyles()

  return (
    <div className='clearfix bshadow0 pbs fw-semibold'>
      <span className={`badge fs-7 ${badgeClass}`} style={{color, background}}>
      {status.charAt(0).toUpperCase() + status.slice(1)}
      </span>
    </div>
  )
}

export default StatusBadge
